import { useRouter } from "next/router";

export const usePagination = () => {
  const router = useRouter();

  const getPaginateData = async (data) => {
    const previousQuery = { ...router.query };

    router.push(
      {
        pathname: router.pathname,
        query: { ...previousQuery, page: data + 1 },
      },
      undefined,
      { shallow: true }
    );
  };

  return { getPaginateData };
};
